module.exports = __webpack_public_path__ + "img/GB.74db19d6.png";